<div nz-row>
    <div nz-col nzSpan="6">
        <span class="pageTitle">Re-Open Partner Query</span>
    </div>
</div>
<div class="create-query-container" nzCompact>
    <form [formGroup]="reOpenQueryForm" (ngSubmit)="onSubmit()" class="ant-advanced-search-form">
        <div class="form-row bg-dark-blue text-white">
            <span class="span-header">Query Details</span>
        </div>
        <br />
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8" nzRequired>Reference Number</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="QueryReferenceNumber" type="text" class="form-control"
                            formControlName="QueryReferenceNumber" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8" nzRequired>Date of Request</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="dateOfRequest" type="text" class="form-control"
                            formControlName="dateOfRequest" readonly />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8" nzRequired>Request Status</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="QueryStatus" type="text" class="form-control"
                            formControlName="QueryStatus" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8" nzRequired>Priority</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <select nz-input id="priority1" class="form-control" formControlName="Priority">
                            <option *ngFor="let p of priorityLevels" [value]="p" >
                                {{priorityLevelMapping[p]}}
                            </option>
                        </select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>


        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8">CC Emails</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <textarea nz-input id="CCEmails" class="form-control" formControlName="CCEmails"
                        data-toggle="tooltip"
                        data-placement="top" 
                        title="Multiple email id's should be separated by semi-colon(;)"></textarea>
                        
                        <div *ngIf="reOpenQueryForm.get('CCEmails')?.invalid && reOpenQueryForm.get('CCEmails')?.touched"
                            class="text-danger">
                            <div *ngIf="reOpenQueryForm.get('CCEmails')?.errors?.['invalidEmails']">
                                Please enter valid email addresses separated by semicolons.
                                Please make correction in <strong>Invalid emails </strong> as - <strong> {{reOpenQueryForm.get('CCEmails')?.errors?.['invalidEmails']}} </strong>
                            </div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8">Confidential</nz-form-label>
                    <nz-form-control [nzSpan]="1">
                        <input nz-input class="form-control" id="Is_Confidential" type="checkbox"
                            formControlName="Is_Confidential" />
                    </nz-form-control>
                </nz-form-item>
            </div>

        </div>

        <div class="form-row bg-dark-blue text-white">
            <span class="span-header">Requestor Details</span>
        </div>

        <br />
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8">Requestor Name</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="RequestorName" type="text" class="form-control"
                            formControlName="RequestorName" readonly />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8">Requestor Email</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="RequestorEmail" type="text" class="form-control"
                            formControlName="RequestorEmail" readonly />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8">Company</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <input nz-input id="CompanyName" type="text" class="form-control" formControlName="CompanyName"
                            readonly />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8" nzRequired>Block</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <!-- Render a textbox if Block_Code is 3 -->
                        <input nz-input *ngIf="currentUser?.Block?.Block_Code !== Constants.ALL_BLOCK_CODE" nz-inputid="blockTxt" type="text"
                            class="form-control" formControlName="block" readonly />

                        <!-- <input nz-input id="block" type="text" class="form-control" formControlName="block" readonly/> -->
                        <nz-select nzRequired *ngIf="currentUser?.Block?.Block_Code == Constants.ALL_BLOCK_CODE" id="blockDdl"
                            class="form-control" formControlName="block" nzPlaceHolder="Select Block">
                            <nz-option *ngFor="let b of blockMaster" [nzValue]="b.Block_Code"
                                [nzLabel]="b.Block_Name"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div class="form-row bg-dark-blue text-white">
            <span class="span-header">Clarification Request Details</span>
        </div>

        <br />
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>

                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8"></nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <button nz-button nzType="primary"
                            routerLink="/clarification-query/view-previous-query-details/{{ queryCode }}/1">
                            Previous Query Resolutions Details
                        </button>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8">Department</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <!-- <select id="department" class="form-control" formControlName="department" (change)="onDepartmentChange($any($event.target).value)">
                            <option value="" selected="true">N/A</option>
                            <option *ngFor="let department of departmentMaster" [value]="department.Department_Code" title="{{ department.Department_Name }}">{{ department.Department_Name }}</option>
                          </select> -->
                        <nz-select id="department" class="form-control" formControlName="department" (ngModelChange)="onDepartmentChange($event)"
                             nzPlaceHolder="Choose" nzAllowClear>

                            <nz-option *ngFor="let department of departmentMaster"
                                [nzValue]="department.Department_Code"
                                [nzLabel]="department.Department_Name"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label [nzSpan]="8">Sub Department</nz-form-label>
                    <nz-form-control [nzSpan]="16">                        
                        <nz-select id="subDepartment123" formControlName="subDepartment" nzPlaceHolder="Choose"
                         nzAllowClear>
                            <nz-option *ngFor="let s of deptSubDeptMaster | orderby: 'Sub_Dept_Name'"
                                [nzValue]="s.Sub_Dept_Code" [nzLabel]="s.Sub_Dept_Name"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="24">
                <nz-form-item>
                    <nz-form-label [nzSpan]="4">CC</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <nz-select id="cc" formControlName="cc" nzMode="multiple" nzPlaceHolder="Select CC">
                            <nz-option *ngFor="let item of partnerUserMaster" [nzLabel]="item.User_Name"
                                [nzValue]="item.User_Code"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="24">
                <nz-form-item>
                    <nz-form-label [nzSpan]="4" nzRequired>Partner Comments</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                        <textarea nz-input id="partnerComments" class="form-control" formControlName="partnerComments" rows="5"></textarea>
                        <div *ngIf="reOpenQueryForm.get('partnerComments')?.invalid && reOpenQueryForm.get('partnerComments')?.touched"
                            class="text-danger">
                            Partner Comments are required.
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="24">
            <div nz-col [nzSpan]="8"></div>
            <div nz-col [nzSpan]="16">
                <button type="submit" nz-button nzType="primary" [disabled]="reOpenQueryForm.invalid">Re-Open</button>
            </div>
        </div>        
    </form>

</div>